import IndexTableRowRenderer from '../index-table/IndexTableRowRenderer';
import ConfigTag from './../configurations/ConfigurationsTag';

export default class ConfigurationIndexTableRowRenderer extends IndexTableRowRenderer {
    constructor(props, indexTableRow) {
        super(props, indexTableRow);
        this.renderNameColumn = this.renderNameColumn.bind(this);
    }

    renderStatusColumn(column, value) {
        return (
            <td>
                {ConfigTag.get(this.props.row.statusValue)}
            </td>
        );
    }

    renderNameColumn(column, value, children) {
        let c = (
            <div>
                <span className="name-sub-title">{this.props.row.number}</span>
            </div>
        )

        return super.renderNameColumn(column, value, c);
    }
}